import {labelConfigSelector} from '../../../data/labelInfos/index.js'
import {FEDEX, FEDEX_360} from '../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {useSelector} from '../../../store.js'
import ConfigButton from './ConfigButton.js'
import {showETDPreshipmentDocsModal} from '../Modals/ETDPreshipmentDocsModal.js'
import {
  Count,
  IfPluralNotZero,
  IfSingle,
  IfZero,
  PluralBlock,
} from '../../../common/components/Plural.js'
import {ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC} from './useLabelProperty.js'

const VALID_SHIPPER_TYPES = [FEDEX, FEDEX_360]

export function formatETDPreshipmentDocsProperty(shipperType) {
  return `${shipperType}__etd_preshipment_docs`
}

export function labelPropertiesFunc(shipperType) {
  return [formatETDPreshipmentDocsProperty(shipperType)]
}

const VALID_LABEL_PROPERTIES = VALID_SHIPPER_TYPES.map((shipperType) =>
  formatETDPreshipmentDocsProperty(shipperType),
)

export default function ETDPreshipmentDocs() {
  const {labelInfoID, shipperType} = useLabelConfigContext()
  const propertySpecs = ETDPreshipmentDocs.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  const labelConfig = useSelector((state) =>
    labelConfigSelector(state, {labelInfoID}),
  )
  const docs = labelConfig[labelProperty] || []

  return (
    <ConfigButton
      label="FedEx® Electronic Trade Documents Preshipment Docs"
      onClick={showETDPreshipmentDocsModal}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
    >
      <PluralBlock array={docs}>
        <IfZero>Edit</IfZero>
        <IfSingle>1 Document</IfSingle>
        <IfPluralNotZero>
          <Count /> Docs
        </IfPluralNotZero>
      </PluralBlock>
    </ConfigButton>
  )
}

ETDPreshipmentDocs.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc() {
      return VALID_LABEL_PROPERTIES
    },
  },
]
